/* eslint-disable import/prefer-default-export */

import { partners } from "../../../../config/constant";
import { products } from "../../resources";
import { calcAgeFromToday } from "../resources";

export const productsUWQuestionnaireMapper = (productId: number) =>
  ({
    [products.GLS]: {
      declare:
        "I hereby declare that I am in good health and do not have any physical or mental defect, deformity or disability. I further declare that I perform all my routine activities independently and that in the last five years, I did not suffer from, am not currently suffering from any ailment or disease (apart from minor ailments such as cold and flu) neither have I received, nor am I currently receiving nor been advised any treatment or investigation and hospitalization for any ailment or disease",
      medicalHealth:
        "Are there any health conditions not mentioned below OR have you received any treatment OR have any sign / symptom for which you have consulted any Doctor / Specialist OR undergone surgery OR Advised to undergo or undergone investigations like blood tests, Xray, ECG, Echo, Ultrasound, CT Scan, MRI, Endoscopy, Colonoscopy, Biopsy, Angiography etc OR taken leave from work for more than 5 days OR been hospitalised for more than 3 days.",
      weight: "Weight",
      height: "Height",
      measurement: "Measurement",
      sufferings: {
        heading: "Have you ever suffered from or currently under treatment for:",
        diabetes: "1. Diabetes?",
        highBloodPressure: "2. High blood pressure, cholesterol, lipid?",
        stroke: "3. Stroke, chest pain, heart attack, or any heart disease?",
        asthma: "4. Asthma or any other respiratory disorder?",
        epilepsy: "5. Epilepsy, paralysis, parkinson's disease, multiple sclerosis?",
        liverDisease: "6. Liver disease, gall bladder disease or any other digestive?",
        kidneyDisease: "7. Kidney disease?",
        bloodDisorder: "8. Blood disorder, endocrine disorder or any musculoskeletal disorder?",
        tumor: "9. Tumor, abnormal cyst, any cancers?",
        anxiety:
          "10. Anxiety, depression or any other mental disorder requiring treatment with antidepressant?",
        aids: "11. A positive test for HIV / AIDS, hepatitis (other than Nohepatitis A and E) or any sexually transmitted diseases?"
      },
      familyMedicalHistory: {
        heading:
          "Have any of your natural parents, brothers or sisters died or suffered from diabetes, hypertension, heart disease, stroke or cancer below the age of 60 years? If 'Yes' please provide relation with such persons, age in years and present state of health (if living), age at death in years and cause of death (if deceased) in additional sheets.",
        familyPersonName: "Name of Person",
        familyRelation: "Relation with Person",
        status: "Status ",
        sufferingAge: "Age of Suffering Person (if living)",
        ageOfDeath: "Age at death of Deceased Person",
        presentStateOfHealth: "Present state of health of Suffering Person (if living)",
        causeDeath: "Cause of Death of Deceased Person"
      },
      smoker: {
        heading: "Do you smoke or chew tobacco ?",
        type: "Type of tobacco",
        cigaratte: "Cigarette",
        bidi: "Bidi",
        cigar: "Cigar",
        panMasala: "Pan Masala",
        gutkha: "Gutka",
        chewing: "Chewing",
        amountConsumed: "Amount Consumed",
        amount: "per day"
      },
      alcohol: {
        heading: "Do you consume alcohol ?",
        type: "Type of alcohol",
        beer: "Beer",
        wine: "Wine",
        liquor: "Hard Liquor",
        frequency: {
          lessThanOnce: "Less than once a week",
          moreThanOnce: "More than once a week",
          once: "Once a week",
          daily: "Daily"
        },
        alcoholAmount: "Amount Consumed",
        amount: "per day",
        amountConsumedNote: "ml per week (Note: one small peg is 30 ml and one large peg is 60 ml)"
      },
      drugs:
        "Have you ever used habit-forming (narcotics/psychotics) drugs or received any alcohol or drug abstinence treatment?",
      disability:
        "Have you had or do you have any form of physical disability, deformity or defect?",
      remarks: "If your answer is ‘Yes’ to any of the above questions, kindly give details ?",
      pregnancy: {
        heading:
          "The following questions need to be answered only if the life to be assured is a female :",
        gyneComplications:
          "a. Have you ever suffered /are suffering from or have ever undergone any investigation or treatment or received medical advice or consulted a physician for any gynecological complications such as miscarriage, medical termination of pregnancy, disorders of cervix,uterus ovary(ies), breast(s), breast lump /cyst, fibrocystic disease etc.",
        pregnant: "Are you pregnant at present ?"
      }
    },
    [products.GHS]: {
      medicalHealth:
        "Are there any health conditions not mentioned below OR have you received any treatment OR have any sign / symptom for which you have consulted any Doctor / Specialist OR undergone surgery OR Advised to undergo or undergone investigations like blood tests, Xray, ECG, Echo, Ultrasound, CT Scan, MRI, Endoscopy, Colonoscopy, Biopsy, Angiography etc OR taken leave from work for more than 5 continous days OR been hospitalised for more than 3 days for any medical conditions including COVID-19 infection in last 5 years",
      weight: "Weight",
      height: "Height",
      measurement: "Measurement",
      sufferings: {
        heading: "Have you ever suffered from or currently under treatment for:",
        diabetesAndSugar: "1. Diabetes mellitus, high blood sugar levels or sugar in urine?",
        bloodPressureHeartAttack:
          "2. High blood pressure, cholesterol, lipids, chest pain, heart attack, heart murmur, shortness of breath or any other heart condition?",
        strokeParalysis:
          "3. Stroke, paralysis, transient ischemic attack, epilepsy, Parkinson's disease, migraine, head injury, multiple sclerosis, tremors, dizzy or fainting spells, blurred or double vision or any other neurological disorder?",
        asthamaTuberculosis:
          "4. Asthma, Tuberculosis, chronic cough, chronic bronchitis, COPD, emphysema, pneumonia, blood in sputum or any other respiratory disorder?",
        indigestion:
          "5. Recurrent indigestion, ulcer, colitis, chronic diarrhoea, jaundice, hepatitis, cirrhosis, gall stone or any other disease of the stomach, bowels, liver, gall  bladder?",
        kidneyStoneBloodUrine:
          "6. Kidney stone, blood in urine, recurrent urinary tract infection, enlarged prostate or any other disease of the kidney and bladder?",
        anaemia:
          "7. Anaemia (Low Haemoglobin), Polycythaemia (High Haemoglobin), Leukaemia (blood cancer), Thalassemia, Bleeding, or any other Blood Disorder?",
        cancerTumor:
          "8. Cancer, tumour, leukemia, enlarged lymph nodes or any abnormal growth or any hormonal disorders or disorders of the blood and lymphatic system, eyes, ear, nose, throat",
        arthritis:
          "9. Arthritis, Gout or Joint Pain, Fracture, Spondylosis, Low Back Pain, muscular dystrophy, or any other Musculoskeletal Disorder?",
        anxietyDepression:
          "10. Loss of sleep, Anxiety, Depression, Panic disorder or any other mental disorder requiring treatment with anti-depressant?",
        thyroid:
          "11. Thyroid (Hypothyroidism, Hyperthyroidism, Goitre) or any other Endocrine Disorder?",
        aids: "12. A positive test for HIV / AIDS, hepatitis (other than Nohepatitis A and E) or any sexually transmitted diseases?",
        otherDisease: "13. Any other disease not stated above?",
        otherDiseaseDetails: "Details"
      },
      occupationEnquiry:
        "Is your occupation associated with any specific hazard or do you take part in activities or have hobbies that could be dangerous in any way for example paragliding, bungee jumping, etc?",
      familyMedicalHistory: {
        heading:
          "Have any of your natural parents, brothers or sisters died or suffered from diabetes, hypertension, heart disease, stroke or cancer below the age of 60 years? If 'Yes' please provide relation with such persons, age in years and present state of health (if living), age at death in years and cause of death (if deceased) in additional sheets.",
        familyPersonName: "Name of Person",
        familyRelation: "Relation with Person",
        status: "Status ",
        sufferingAge: "Age of Suffering Person (if living)",
        ageOfDeath: "Age at death of Deceased Person",
        presentStateOfHealth: "Present state of health of Suffering Person (if living)",
        causeDeath: "Cause of Death of Deceased Person"
      },
      smoker: {
        heading: "Do you smoke or chew tobacco ?",
        type: "Type of tobacco",
        cigaratte: "Cigarette",
        bidi: "Bidi",
        cigar: "Cigar",
        panMasala: "Pan Masala",
        gutkha: "Gutka",
        chewing: "Chewing",
        amountConsumed: "Amount Consumed",
        amount: "per day",
        consumingSince: "Consuming since",
        consumingFrequency: "in Years"
      },
      alcohol: {
        heading: "Do you consume alcohol ?",
        type: "Type of alcohol",
        beer: "Beer",
        wine: "Wine",
        liquor: "Hard Liquor",
        frequency: {
          lessThanOnce: "Less than once a week",
          moreThanOnce: "More than once a week",
          once: "Once a week",
          daily: "Daily"
        },
        alcoholAmount: "Amount Consumed",
        amount: "per day",
        amountConsumedNote: "ml per week (Note: one small peg is 30 ml and one large peg is 60 ml)",
        consumingSince: "Consuming since",
        consumingFrequency: "in Years"
      },
      drugs:
        "Have you ever used habit-forming (narcotics/psychotics) drugs or received any alcohol or drug abstinence treatment?",
      disability:
        "Have you had or do you have any form of physical disability, deformity or defect?",
      remarks: "If your answer is 'Yes' to any of the above questions, kindly give details ?",
      pregnancy: {
        heading:
          "The following questions needs to be answered only if the Member to be insured OR Joint Life (if any) is a female:",
        gyneComplications:
          "a. Have you ever suffered /are suffering from or have ever undergone any investigation or treatment or received medical advice or consulted a physician for any gynecological complications such as miscarriage, medical termination of pregnancy, disorders of cervix,uterus ovary(ies), breast(s), breast lump /cyst, fibrocystic disease etc.",
        pregnant: "Are you pregnant at present ?"
      },
      extraQuestions: {
        hospitalisation:
          "Are you suffering from or have you ever suffered from any accident, illness, disease or ailment which required hospitalisation, nursing-care or surgery or which led to residual disability of any sort?",
        underTreatment:
          "Are you currently under treatment or medication or have you, in the past one year, been advised to undergo surgery, medical investigation or medical treatment for any medical condition (other than minor conditions like cold, flu, etc.)?",
        majorDisorder:
          "Are you suffering from or have you ever suffered from or have ever been diagnosed or received treatment for medical conditions such as but not limited to high blood pressure, Diabetes, chest pain, heart attack or any other heart condition; stroke, transient ischemic attack or any other cerebrovascular disease; diabetes or raised blood sugar or Sugar in Urine or any other endocrinal disease; kidney disease; HIV / AIDS or AIDS related complex; any cancer or tumour or Lump; asthma or any other respiratory disease; any mental or nervous disease; hepatitis or any other liver disease; blood disorders; digestive disorders; paraplegia or any other disorder of the bones, spine or muscle, or any other Medical condition not mentioned above?",
        existingApplication:
          "Has any application or proposal for life, health, accident or critical illness including renewal and reinstatement ever been declined, deferred, withdrawn or accepted at special rates or terms or with exclusions by any Insurance company?",
        familyHealth:
          "Have any of your parents or brother(s) or sister(s) died before age 60 or suffered from diabetes, high blood pressure, cancer, heart disease, raised cholesterol, kidney failure or stroke or any hereditary diseases?"
      }
    },
    [products.GHS_FOR_JIO]: {
      weight: "Weight",
      height: "Height",
      measurement: "Measurement",
      sufferingTreatment: {
        heading:
          "Have you ever suffered from / been diagnosed with / been treated or awaiting treatment for any of the following? (Please tick the relevant)",
        heartDisease: "Heart Disease, Stroke / TIA",
        cancerTumor: "Cancer/Tumor",
        lungDisease: "Lung Disease / Asthma / Tuberculosis",
        kidneyDisease: "Kidney Disease",
        diabetes: "Diabetes",
        hivAidsSTI: "HIV/AIDS Infection / Sexually Transmitted Infections",
        highBloodPressure: "High Blood Pressure",
        highCholesterol: "High Cholesterol",
        congenitalDefect: "Congenital defect/ Genetic Disorders/physical deformity / Autoimmune",
        thyroidDisorder: "Thyroid Disorder",
        chronicDigestiveDisorder: "Chronic Digestive Disorder",
        genitourinaryHearingVisionDisorder:
          "Genitourinary / Any disease or Disorder of Hearing, Speech or Vision excluding Refractive Errors",
        liverDisease: "Liver Disease / Hepatitis B or C",
        paralysis: "Paralysis, Epilepsy, Any Mental / Psychiatric Disorder",
        endocrineDisorder: "Endocrine Disorder",
        brainNervousSystemDisorder:
          "Any Disorder Of Brain Or Nervous System, Arthritis, Disorder Of Muscles/ Bones /joints, Blood Or Circulatory Disorder"
      },
      anyOtherDisease:
        "Any other disorder not mentioned above If yes, please provide details for Member",
      weightLossProgram:
        "Has there been any variation in weight of more than 5 kg in the past 6 months (other than weight loss program)?",
      investigateCheckups:
        "During the last 5 years, have you been advised to undergo any investigations (including but, not limited to basic radiological and blood tests other than normal Health Check-ups and Insurance Medicals, or have had adverse result for any blood tests, X-Rays, ECG, Stress Test, Biopsies, CT Scan, MRI, Ultra-sonography or 2D / 3D Echo) or undergone any surgery or been hospitalized or received any treatment for any medical condition (except for minor cough, cold or flu) for a continuous period of more than 7 days?",
      personalConsumption: {
        heading: "Do you : - (Please tick YES if any one or more is relevant)",
        smoking: "(a) Consume more than 10 cigarettes, bidi's per day?",
        tobacco: "(b) Chew more than 5 pouches tobacco per day ?",
        alcohol: "(c) Consume more than 2 pegs of alcohol per day",
        drugNarcotics:
          "(d) Consumption of narcotics or habit forming drugs without medical advice in any form?"
      },
      occupationQuery: {
        isOccupationHazardious:
          "Is your occupation associated with any specific hazard? (Please tick YES if any one or more is relevant)",
        hazardOptions: {
          mines: "Mines",
          explosives: "Explosives",
          radiation: "Radiation",
          corrosiveChemicals: "Corrosive Chemicals"
        },
        hobbyQuery:
          "Do you take part in activities or have hobbies that could be dangerous in any way",
        hobbyOptions: {
          aviation: "Aviation other than as a fare paying passenger",
          diving: "Professional diving",
          mountaineering: "Mountaineering",
          seaDiving: "Deep sea diving",
          motorRacing: "Motor racing",
          bungeeJumping: "Bungee jumping"
        }
      },
      femaleOrientedQuery: "Are you currently pregnant?",
      femalePregnanacyQuery:
        "Have you suffered from any gynaecological problems or illness related to breasts, uterus or ovary or pregnancy related complications?"
    },
    [products.GHS_IDBI]: {
      medicalHealth:
        "Are there any health conditions not mentioned below OR have you received any treatment OR have any sign / symptom for which you have consulted any Doctor / Specialist OR undergone surgery OR Advised to undergo or undergone investigations like blood tests, Xray, ECG, Echo, Ultrasound, CT Scan, MRI, Endoscopy, Colonoscopy, Biopsy, Angiography etc OR taken leave from work for more than 5 continous days OR been hospitalised for more than 3 days for any medical conditions including COVID-19 infection in last 5 years",
      weight: "Weight",
      height: "Height",
      measurement: "Measurement",
      sufferings: {
        heading: "Have you ever suffered from or currently under treatment for:",
        diabetesAndSugar: "1. Diabetes mellitus, high blood sugar levels or sugar in urine?",
        bloodPressureHeartAttack:
          "2. High blood pressure, cholesterol, lipids, chest pain, heart attack, heart murmur, shortness of breath or any other heart condition?",
        strokeParalysis:
          "3. Stroke, paralysis, transient ischemic attack, epilepsy, Parkinson's disease, migraine, head injury, multiple sclerosis, tremors, dizzy or fainting spells, blurred or double vision or any other neurological disorder?",
        asthamaTuberculosis:
          "4. Asthma, Tuberculosis, chronic cough, chronic bronchitis, COPD, emphysema, pneumonia, blood in sputum or any other respiratory disorder?",
        indigestion:
          "5. Recurrent indigestion, ulcer, colitis, chronic diarrhoea, jaundice, hepatitis, cirrhosis, gall stone or any other disease of the stomach, bowels, liver, gall  bladder?",
        kidneyStoneBloodUrine:
          "6. Kidney stone, blood in urine, recurrent urinary tract infection, enlarged prostate or any other disease of the kidney and bladder?",
        anaemia:
          "7. Anaemia (Low Haemoglobin), Polycythaemia (High Haemoglobin), Leukaemia (blood cancer), Thalassemia, Bleeding, or any other Blood Disorder?",
        cancerTumor:
          "8. Cancer, tumour, leukemia, enlarged lymph nodes or any abnormal growth or any hormonal disorders or disorders of the blood and lymphatic system, eyes, ear, nose, throat",
        arthritis:
          "9. Arthritis, Gout or Joint Pain, Fracture, Spondylosis, Low Back Pain, muscular dystrophy, or any other Musculoskeletal Disorder?",
        anxietyDepression:
          "10. Loss of sleep, Anxiety, Depression, Panic disorder or any other mental disorder requiring treatment with anti-depressant?",
        thyroid:
          "11. Thyroid (Hypothyroidism, Hyperthyroidism, Goitre) or any other Endocrine Disorder?",
        aids: "12. A positive test for HIV / AIDS, hepatitis (other than Nohepatitis A and E) or any sexually transmitted diseases?",
        otherDisease: "13. Any other disease not stated above?",
        otherDiseaseDetails: "Details"
      },
      occupationEnquiry:
        "Is your occupation associated with any specific hazard or do you take part in activities or have hobbies that could be dangerous in any way for example paragliding, bungee jumping, etc?",
      familyMedicalHistory: {
        heading:
          "Have any of your natural parents, brothers or sisters died or suffered from diabetes, hypertension, heart disease, stroke or cancer below the age of 60 years? If 'Yes' please provide relation with such persons, age in years and present state of health (if living), age at death in years and cause of death (if deceased) in additional sheets.",
        familyPersonName: "Name of Person",
        familyRelation: "Relation with Person",
        status: "Status ",
        sufferingAge: "Age of Suffering Person (if living)",
        ageOfDeath: "Age at death of Deceased Person",
        presentStateOfHealth: "Present state of health of Suffering Person (if living)",
        causeDeath: "Cause of Death of Deceased Person"
      },
      smoker: {
        heading: "Do you smoke or chew tobacco ?",
        type: "Type of tobacco",
        cigaratte: "Cigarette",
        bidi: "Bidi",
        cigar: "Cigar",
        panMasala: "Pan Masala",
        gutkha: "Gutka",
        chewing: "Chewing",
        amountConsumed: "Amount Consumed",
        amount: "per day",
        consumingSince: "Consuming since",
        consumingFrequency: "in Years"
      },
      alcohol: {
        heading: "Do you consume alcohol ?",
        type: "Type of alcohol",
        beer: "Beer",
        wine: "Wine",
        liquor: "Hard Liquor",
        frequency: {
          lessThanOnce: "Less than once a week",
          moreThanOnce: "More than once a week",
          once: "Once a week",
          daily: "Daily"
        },
        alcoholAmount: "Amount Consumed",
        amount: "per day",
        amountConsumedNote: "ml per week (Note: one small peg is 30 ml and one large peg is 60 ml)",
        consumingSince: "Consuming since",
        consumingFrequency: "in Years"
      },
      drugs:
        "Have you ever used habit-forming (narcotics/psychotics) drugs or received any alcohol or drug abstinence treatment?",
      disability:
        "Have you had or do you have any form of physical disability, deformity or defect?",
      remarks: "If your answer is 'Yes' to any of the above questions, kindly give details ?",
      pregnancy: {
        heading:
          "The following questions needs to be answered only if the Member to be insured OR Joint Life (if any) is a female:",
        gyneComplications:
          "a. Have you ever suffered /are suffering from or have ever undergone any investigation or treatment or received medical advice or consulted a physician for any gynecological complications such as miscarriage, medical termination of pregnancy, disorders of cervix,uterus ovary(ies), breast(s), breast lump /cyst, fibrocystic disease etc.",
        pregnant: "Are you pregnant at present ?"
      },
      extraQuestions: {
        hospitalisation:
          "Are you suffering from or have you ever suffered from any accident, illness, disease or ailment which required hospitalisation, nursing-care or surgery or which led to residual disability of any sort?",
        underTreatment:
          "Are you currently under treatment or medication or have you, in the past one year, been advised to undergo surgery, medical investigation or medical treatment for any medical condition (other than minor conditions like cold, flu, etc.)?",
        majorDisorder:
          "Are you suffering from or have you ever suffered from or have ever been diagnosed or received treatment for medical conditions such as but not limited to high blood pressure, Diabetes, chest pain, heart attack or any other heart condition; stroke, transient ischemic attack or any other cerebrovascular disease; diabetes or raised blood sugar or Sugar in Urine or any other endocrinal disease; kidney disease; HIV / AIDS or AIDS related complex; any cancer or tumour or Lump; asthma or any other respiratory disease; any mental or nervous disease; hepatitis or any other liver disease; blood disorders; digestive disorders; paraplegia or any other disorder of the bones, spine or muscle, or any other Medical condition not mentioned above?",
        existingApplication:
          "Has any application or proposal for life, health, accident or critical illness including renewal and reinstatement ever been declined, deferred, withdrawn or accepted at special rates or terms or with exclusions by any Insurance company?",
        familyHealth:
          "Have any of your parents or brother(s) or sister(s) died before age 60 or suffered from diabetes, high blood pressure, cancer, heart disease, raised cholesterol, kidney failure or stroke or any hereditary diseases?"
      }
    }
  })[productId!];

/* eslint-disable security/detect-object-injection */
export const getQuestionnaireMapper = (productId: number, partnerId: string) => {
  const mapper = {
    [partners.FEDERAL]: {
      [products.GLS]: productsUWQuestionnaireMapper(products.GLS),
      [products.GHS]: productsUWQuestionnaireMapper(products.GHS)
    },
    [partners.IDBI]: {
      [products.GLS]: productsUWQuestionnaireMapper(products.GLS),
      [products.GHS_IDBI]: productsUWQuestionnaireMapper(products.GHS_IDBI)
    },
    [partners.JIO]: {
      [products.GHS_FOR_JIO]: productsUWQuestionnaireMapper(products.GHS_FOR_JIO)
    }
  };
  return mapper?.[partnerId]?.[productId];
};

export const MEDICAL_ADD_QUE = {
  sumAssured: 4000000,
  age: {
    min: 18,
    max: 50
  }
};

export const displayAdditionalQue = (sumAssured: number, dob: string) => {
  const age = calcAgeFromToday(dob);
  return (
    sumAssured <= MEDICAL_ADD_QUE.sumAssured &&
    age >= MEDICAL_ADD_QUE.age.min &&
    age <= MEDICAL_ADD_QUE.age.max
  );
};
